import React, { useCallback, useMemo, useState } from "react";

import type { Notification } from "./_context/NotificationContext";
import { NotificationContext } from "./_context/NotificationContext";

import { AlertV2 } from "@/components/molecules/Alert";
import { Snackbar } from "@/components/molecules/Snackbar";

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState<Notification | null>(null);

  const notify = useCallback((notification: Notification) => {
    setNotification(notification);
    setOpen(true);
  }, []);

  const contextValue = useMemo(() => ({ notify }), [notify]);

  const handleClose = (_event?: unknown, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <NotificationContext value={contextValue}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={notification?.duration}
        onClose={handleClose}
      >
        <div>
          <AlertV2 severity={notification?.severity} onClose={handleClose}>
            {notification?.message}
          </AlertV2>
        </div>
      </Snackbar>
    </NotificationContext>
  );
};
